import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DynamicTable from "../../../../datatable/DynamicTable";
import useStore from "../../../../hooks/useStore";
import { observer } from "mobx-react";
import {
  ApprovalEnums,
  FINANCIALS_LABELS,
  PERMISSBLE_LIMIT_GUIDANCE,
  STATIC_GROUPS,
  USER_ROLE,
} from "../../../../constants/constants";
import DashboardHistogram from "../../../../components/dashboard-chart/dashboard-histogram";
import Financials from "../../../../components/financials";
import Performance from "../../../../components/performance";
import MobileTable from "../../../../components/mobileTable/mobileTable";
import PaginationControls from "../../../../datatable/paginationControls";
import { findKpi } from "../../../../utils/helpers";
import { Modal, Button } from "react-bootstrap";
import { useAuth } from "../../../../context/authProvider";
import LogTableBody from "../../logForms/environmentLog";
import * as XLSX from 'xlsx';

import { groupByConsecutiveGroups } from "../../../../utils/helpers";

const WasteDashboard = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [selectedFormId, setSelectedFormId] = useState(null);
  const { showAlert } = useAuth();

  const navigate = useNavigate();
  const {
    userStore: { isLoggedIn, path, employeeKpis, user },
    companyStore: { units, fetchUnits, kpiName, companyUnit,catId, subCatId, kpiId, assignUnitsRaw, fetchAssignUnits, getCompanyUnitName},
    formStore: { fetchForms, forms, approveForm, deleteForm, logRaw, logData, fetchFieldsForExcel },
    wasteStore: { fetchWasteByYear }
  } = useStore();

  const kpi = useMemo(
    () => findKpi({ kpis: employeeKpis, value: kpiName, field: "name" }),
    [employeeKpis, kpiName]
  );

  useEffect(() => {
    if (!assignUnitsRaw?.length) {
      fetchAssignUnits();
    }
  }, [assignUnitsRaw]);

  const handleModalOpen = (type, formId) => {
    setModalType(type);
    setSelectedFormId(formId);
    setShowModal(true);
  };
  const handleModalLogShow = async (formId) => {
    await logData({ formId });
    setModalType("log");
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedFormId(null);
    setModalType(null);
  };

  const handleConfirmAction = async () => {
    if (selectedFormId) {
      if (modalType === "approve") {
        await approveForm({
          formId: selectedFormId,
          type: "waste",
          showAlert,
          status: ApprovalEnums.Approved,
          kpiName,
          year,
        });
      } else if (modalType === "delete") {
        await deleteForm({
          formId: selectedFormId,
          type: "waste",
          showAlert,
          status: ApprovalEnums.Pending,
          kpiName,
          year,
        });
      }
      handleModalClose();
    }
  };


  

  const groupFormStructureWithLabels = (formStructure, page) => {
    if (!Array.isArray(formStructure)) return [];
  
    const grouped = {};
  
    formStructure.forEach((field) => {
      const groupKey = field?.group?.[0] || "Unknown";
      const label = STATIC_GROUPS?.[page]?.[groupKey] || groupKey;
  
      if (!grouped[groupKey]) {
        grouped[groupKey] = {
          group: groupKey,
          label,
          fieldIds: new Set(),
        };
      }
  
      grouped[groupKey].fieldIds.add(String(field.fieldId));
    });
  
    return Object.values(grouped).map((group) => ({
      ...group,
      fieldIds: Array.from(group.fieldIds),
    }));
  };
  
  const summarizeApprovedValuesByMonthGroup = (groupedStructure, approvedData, fiscalYearStart) => {
    const months = [
      "April", "May", "June", "July", "August", "September",
      "October", "November", "December", "January", "February", "March"
    ];
  
    const monthToYearMap = {};
    months.forEach((month) => {
      const isNextYear = ["January", "February", "March"].includes(month);
      monthToYearMap[month] = isNextYear ? fiscalYearStart + 1 : fiscalYearStart;
    });
  
    return groupedStructure.map((group, index) => {
      const row = {
        ID: index + 1,
        Label: group.label,
      };
  
      months.forEach((month) => {
        const expectedYear = String(monthToYearMap[month]);
        const normalizedMonth = month.toLowerCase();
  
        const filtered = approvedData.filter((item) => {
          const itemMonth = (item.frequencyMonth || "").toLowerCase();
          const itemYear = String(item.frequencyYear);
          const itemFieldId = String(item.fieldId);
  
          return (
            itemMonth === normalizedMonth &&
            itemYear === expectedYear &&
            group.fieldIds.includes(itemFieldId)
          );
        });
  
        const totalPrev = filtered.reduce((sum, item) => sum + (Number(item.prevValue) || 0), 0);
        row[`${month} ${expectedYear}`] = totalPrev || '';
      });
  
      return row;
    });
  };
  


  const getUnitDisplay = (field, match) => {
    return (
      match?.unitmaster?.shortName ||  
      match?.unitShortName ||         
      match?.unitName ||              
      match?.unit ||                 
      field?.unit ||                
      units?.find(u =>
        u.id === field?.unitId ||
        u.id === field?.unit ||
        u.fullName === field?.unit ||
        u.shortName === field?.unit
      )?.shortName ||
      "N/A"
    );
  };
  
  
   

//   const handleDownloadExcel = async () => {
//    // setIsExcelLoading(true);
//     try {
//       const startYear = year;
//       const endYear = year + 1;
  
//       const approvedForms = forms?.records?.filter(f => f.approvalStatus === "approved") || [];
  
//       if (approvedForms.length === 0) {
//         showAlert("No approved forms found");
//         return;
//       }
  
//       const approvedFormIds = approvedForms.map(f => f.formId);
  
//       const wasteData = await fetchWasteByYear({ startYear, endYear, showAlert });
//       console.log("wasteData", wasteData);
  
//       if (!wasteData || wasteData.length === 0) {
//         showAlert("No waste data available for the selected year.");
//         return;
//       }
  
//       const approvedData = wasteData.filter(item =>
//         approvedFormIds.includes(item.formId)
//       );
  
//       if (approvedData.length === 0) {
//         showAlert("No approved waste data available for the selected year.");
//         return;
//       }
  
//       const fullStructure = await fetchFieldsForExcel(catId, subCatId, kpiId);
//       if (!fullStructure || fullStructure.length === 0) {
//         showAlert("Full field structure not found");
//         return;
//       }
  
//       const months = [
//         "April", "May", "June", "July", "August", "September",
//         "October", "November", "December", "January", "February", "March"
//       ];
//       const monthToYearMap = {};
//       months.forEach(month => {
//         monthToYearMap[month] = ["January", "February", "March"].includes(month)
//           ? endYear
//           : startYear;
//       });
  
//       const grouped = {};
//       fullStructure.forEach(field => {
//         const groupKey = field?.group?.[0] || "Unknown";
//         if (!grouped[groupKey]) grouped[groupKey] = [];
//         grouped[groupKey].push(field);
//       });
  
//       const excelData = [];
//       let idCounter = 1;
  
//       for (const [groupKey, fields] of Object.entries(grouped)) {
//         const groupLabel = STATIC_GROUPS?.waste?.[groupKey] || groupKey;
  
//         // Main Group Heading
//         excelData.push({}, {
//           "Sr. No.": idCounter++,
//           "KPI Name": groupLabel,
//           "UOM": "",
//           ...Object.fromEntries(months.map(month => [`${month} ${monthToYearMap[month]}`, ""]))
//         });
  
//         const subGroups = groupByConsecutiveGroups(fields.sort((a, b) => Number(a.fieldId) - Number(b.fieldId)));
  
//         for (const subGroup of subGroups) {
//           const subGroupKey = subGroup[0]?.group;
//           const subLabel = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"].includes(subGroupKey)
//             ? ""
//             : STATIC_GROUPS?.waste?.[subGroupKey] || subGroupKey;
  
//           if (subLabel) {
//             excelData.push({
//               "Sr. No.": "",
//               "KPI Name": subLabel,
//               "UOM": "",
//               ...Object.fromEntries(months.map(month => [`${month} ${monthToYearMap[month]}`, ""]))
//             });
//           }
  
//           subGroup.forEach(field => {
//             const row = {
//               "Sr. No.": "",
//               "KPI Name": `a. ${field.fieldName || "-"}`,
//               "UOM": "",
//             };
  
//             months.forEach(month => {
//               const expectedYear = String(monthToYearMap[month]);
//               const normalizedMonth = month.toLowerCase();
  
//               const match = approvedData.find(item =>
//                 String(item.fieldId) === String(field.fieldId) &&
//                 String(item.frequencyYear) === expectedYear &&
//                 item.frequencyMonth?.toLowerCase() === normalizedMonth
//               );
  
//               row[`${month} ${expectedYear}`] = match ? match.prevValue : "";
//               // if (match?.unitName) {
//               //   row["Unit"] = field.unit || match.unit;
//               // }
//               if (!row["UOM"] && match) {
//                 row["UOM"] = getUnitDisplay(field, match);
//               }

           
//             });
  
//             excelData.push(row);
//           });
//         }
//       }
  
//       if (excelData.length === 0) {
//         showAlert("Nothing to export");
//         return;
//       }
  
//       //const worksheet = XLSX.utils.json_to_sheet(excelData);

//       const unitName = getCompanyUnitName?.() ?? "Unknown Unit";

// // 1. Add header metadata (Client name, Location, etc.)
// const sheetData = [
//   ["Client Name", "Harman Finochem Limited"],
//   ["Location", unitName],
//   [], // Empty row
// ];

// // 2. Create rows from excelData (which is array of objects)
// if (excelData.length > 0) {
//   const headers = Object.keys(excelData.find(row => Object.keys(row).length > 0) || {});

//   // Push the header row
//   sheetData.push(headers);

//   // Push all the data rows
//   excelData.forEach(obj => {
//     const row = headers.map(h => obj[h] ?? "");
//     sheetData.push(row);
//   });
// }

// // 3. Create the worksheet and export
// const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Waste Monthly Summary");
//       XLSX.writeFile(workbook, `Waste_KPI_Summary_${startYear}-${endYear}.xlsx`);
  
//       showAlert("Excel downloaded successfully", true);
//     } catch (err) {
//       console.error("Download error", err);
//       showAlert(err.message || "Failed to export");
//     } finally {
//       //setIsExcelLoading(false);
//     }
//   };
   
    

  // const handleDownloadExcel = async () => {
  //   try {
  //     const selectedYear = year;
  //     // Fetch all approved waste data for the selected companyUnit and year
  //     const wasteData = await fetchWasteByYear({ year: selectedYear, companyUnit, showAlert });
  //     console.log("wasteData",wasteData)
  //     if (!wasteData || wasteData.length === 0) {
  //       showAlert("No waste data available for the selected year.");
  //       return;
  //     }
  //     // All data returned is already approved and for the selected companyUnit
  //     const approvedData = wasteData;
  //     const fullStructure = await fetchFieldsForExcel(catId, subCatId, kpiId);
  //     if (!fullStructure || fullStructure.length === 0) {
  //       showAlert("Full field structure not found");
  //       return;
  //     }
  //     const months = [
  //       "January", "February", "March", "April", "May", "June",
  //       "July", "August", "September", "October", "November", "December"
  //     ];
  //     const grouped = {};
  //     fullStructure.forEach(field => {
  //       const groupKey = field?.group?.[0] || "Unknown";
  //       if (!grouped[groupKey]) grouped[groupKey] = [];
  //       grouped[groupKey].push(field);
  //     });
  //     const excelData = [];
  //     let idCounter = 1;
  //     for (const [groupKey, fields] of Object.entries(grouped)) {
  //       const groupLabel = STATIC_GROUPS?.waste?.[groupKey] || groupKey;
  //       // Main Group Heading
  //       excelData.push({}, {
  //         "Sr. No.": idCounter++,
  //         "KPI Name": groupLabel,
  //         "UOM": "",
  //         ...Object.fromEntries(months.map(month => [`${month} ${selectedYear}`, ""])),
  //         Total: ""
  //       });
  //       // Track group totals for each month and overall
  //       const groupMonthTotals = {};
  //       let groupTotalSum = 0;
  //       months.forEach(month => {
  //         groupMonthTotals[month] = 0;
  //       });
  //       const subGroups = groupByConsecutiveGroups(fields.sort((a, b) => Number(a.fieldId) - Number(b.fieldId)));
  //       for (const subGroup of subGroups) {
  //         const subGroupKey = subGroup[0]?.group;
  //         let subLabel = "";
  //         if (["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"].includes(subGroupKey)) {
  //           subLabel = "";
  //         } else if (
  //           subGroupKey &&
  //           subGroupKey.length > 1 &&
  //           STATIC_GROUPS?.waste?.[subGroupKey[0]] &&
  //           STATIC_GROUPS?.waste?.[subGroupKey]
  //         ) {
  //           // For B1, B2, B3, C1, C2, etc.
  //           subLabel = `${STATIC_GROUPS.waste[subGroupKey[0]]} ${STATIC_GROUPS.waste[subGroupKey]}`;
  //         } else {
  //           subLabel = STATIC_GROUPS?.waste?.[subGroupKey] || subGroupKey;
  //         }
  //         if (subLabel) {
  //           excelData.push({
  //             "Sr. No.": "",
  //             "KPI Name": subLabel,
  //             "UOM": "",
  //             ...Object.fromEntries(months.map(month => [`${month} ${selectedYear}`, ""])),
  //             Total: ""
  //           });
  //         }
  //         subGroup.forEach(field => {
  //           const row = {
  //             "Sr. No.": "",
  //             "KPI Name": `a. ${field.fieldName || "-"}`,
  //             "UOM": "",
  //           };
  //           let totalSum = 0;
  //           months.forEach(month => {
  //             const monthIndex = months.indexOf(month) + 1; // 1-based month
  //             const expectedYear = String(selectedYear);
  //             // Monthly records
  //             const monthlySum = approvedData
  //               .filter(item =>
  //                 String(item.fieldId) === String(field.fieldId) &&
  //                 item.frequencyType === "Monthly" &&
  //                 String(item.frequencyYear) === expectedYear &&
  //                 item.frequencyMonth?.toLowerCase() === month.toLowerCase()
  //               )
  //               .reduce((sum, item) => sum + (Number(item.prevValue) || 0), 0);
  //             // Daily records
  //             const dailySum = approvedData
  //               .filter(item => {
  //                 if (
  //                   String(item.fieldId) !== String(field.fieldId) ||
  //                   item.frequencyType !== "Daily" ||
  //                   !item.frequencyDate
  //                 ) return false;
  //                 const date = new Date(item.frequencyDate);
  //                 return (
  //                   date.getFullYear() === Number(selectedYear) &&
  //                   date.getMonth() + 1 === monthIndex
  //                 );
  //               })
  //               .reduce((sum, item) => sum + (Number(item.prevValue) || 0), 0);
  //             const total = monthlySum + dailySum;
  //             row[`${month} ${selectedYear}`] = total > 0 ? Number(total).toFixed(2) : "";
  //             totalSum += total;
  //             groupMonthTotals[month] += total;
  //             // Set unit only once
  //             if (!row["UOM"]) {
  //               const match = approvedData.find(item => String(item.fieldId) === String(field.fieldId) && ((item.frequencyType === "Monthly" && String(item.frequencyYear) === expectedYear && item.frequencyMonth?.toLowerCase() === month.toLowerCase()) || (item.frequencyType === "Daily" && item.frequencyDate && new Date(item.frequencyDate).getFullYear() === Number(selectedYear) && new Date(item.frequencyDate).getMonth() + 1 === monthIndex)));
  //               if (match) {
  //                 row["UOM"] = getUnitDisplay(field, match);
  //               }
  //             }
  //           });
  //           row["Total"] = totalSum > 0 ? Number(totalSum).toFixed(2) : "";
  //           groupTotalSum += totalSum;
  //           excelData.push(row);
  //         });
  //       }
  //       // Add summary row for group totals
  //       const groupSummaryRow = {
  //         "Sr. No.": "",
  //         "KPI Name": `${groupLabel} Total` ,
  //         "UOM": "",
  //       };
  //       months.forEach(month => {
  //         groupSummaryRow[`${month} ${selectedYear}`] = groupMonthTotals[month] > 0 ? Number(groupMonthTotals[month]).toFixed(2) : "";
  //       });
  //       groupSummaryRow["Total"] = groupTotalSum > 0 ? Number(groupTotalSum).toFixed(2) : "";
  //       excelData.push(groupSummaryRow);
  //     }
  //     if (excelData.length === 0) {
  //       showAlert("Nothing to export");
  //       return;
  //     }
  //     const unitName = getCompanyUnitName?.() ?? "Unknown Unit";
  //     const sheetData = [
  //       ["Client Name", "Harman Finochem Limited"],
  //       ["Location", unitName],
  //       [], // Empty row
  //     ];
  //     if (excelData.length > 0) {
  //       const headers = Object.keys(excelData.find(row => Object.keys(row).length > 0) || {});
  //       sheetData.push(headers);
  //       excelData.forEach(obj => {
  //         const row = headers.map(h => obj[h] ?? "");
  //         sheetData.push(row);
  //       });
  //     }
  //     const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
  //     const workbook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Waste Monthly Summary");
  //     XLSX.writeFile(workbook, `Waste_KPI_Summary_${selectedYear}.xlsx`);
  //     showAlert("Excel downloaded successfully", true);
  //   } catch (err) {
  //     console.error("Download error", err);
  //     showAlert(err.message || "Failed to export");
  //   }
  // };


  const handleDownloadExcel = async () => {
  try {
    const selectedYear = year;
    // Fetch all approved waste data for the selected companyUnit and year
    const wasteData = await fetchWasteByYear({ year: selectedYear, companyUnit, showAlert });
    console.log("wasteData", wasteData);
    
    if (!wasteData || wasteData.length === 0) {
      showAlert("No waste data available for the selected year.");
      return;
    }
    
    // All data returned is already approved and for the selected companyUnit
    const approvedData = wasteData;
    const fullStructure = await fetchFieldsForExcel(catId, subCatId, kpiId);
    
    if (!fullStructure || fullStructure.length === 0) {
      showAlert("Full field structure not found");
      return;
    }
    
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    
    const grouped = {};
    fullStructure.forEach(field => {
      const groupKey = field?.group?.[0] || "Unknown";
      if (!grouped[groupKey]) grouped[groupKey] = [];
      grouped[groupKey].push(field);
    });
    
    const excelData = [];
    let idCounter = 1;
    
    for (const [groupKey, fields] of Object.entries(grouped)) {
      const groupLabel = STATIC_GROUPS?.waste?.[groupKey] || groupKey;
      
      // Main Group Heading
      excelData.push({}, {
        "Sr. No.": idCounter++,
        "KPI Name": groupLabel,
        "UOM": "",
        ...Object.fromEntries(months.map(month => [`${month} ${selectedYear}`, ""])),
        Total: ""
      });
      
      // Track group totals for each month and overall
      const groupMonthTotals = {};
      let groupTotalSum = 0;
      months.forEach(month => {
        groupMonthTotals[month] = 0;
      });
      
      const subGroups = groupByConsecutiveGroups(fields.sort((a, b) => Number(a.fieldId) - Number(b.fieldId)));
      
      for (const subGroup of subGroups) {
        const subGroupKey = subGroup[0]?.group;
        let subLabel = "";
        
        if (["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"].includes(subGroupKey)) {
          subLabel = "";
        } else if (
          subGroupKey &&
          subGroupKey.length > 1 &&
          STATIC_GROUPS?.waste?.[subGroupKey[0]] &&
          STATIC_GROUPS?.waste?.[subGroupKey]
        ) {
          // For B1, B2, B3, C1, C2, etc.
          subLabel = `${STATIC_GROUPS.waste[subGroupKey[0]]} ${STATIC_GROUPS.waste[subGroupKey]}`;
        } else {
          subLabel = STATIC_GROUPS?.waste?.[subGroupKey] || subGroupKey;
        }
        
        if (subLabel) {
          excelData.push({
            "Sr. No.": "",
            "KPI Name": subLabel,
            "UOM": "",
            ...Object.fromEntries(months.map(month => [`${month} ${selectedYear}`, ""])),
            Total: ""
          });
        }
        
        subGroup.forEach(field => {
          const row = {
            "Sr. No.": "",
            "KPI Name": `a. ${field.fieldName || "-"}`,
            "UOM": "",
          };
          
          const expectedYear = String(selectedYear);
          
          // Check if this field has yearly data first
          const yearlyData = approvedData.find(item =>
            String(item.fieldId) === String(field.fieldId) &&
            item.frequencyType === "Yearly" &&
            String(item.frequencyYear) === expectedYear
          );
          
          let totalSum = 0;
          let hasYearlyData = false;
          
          if (yearlyData && yearlyData.prevValue && Number(yearlyData.prevValue) > 0) {
            // Handle yearly data
            hasYearlyData = true;
            const yearlyValue = Number(yearlyData.prevValue);
            totalSum = yearlyValue;
            
            // For yearly data, you can choose one of these approaches:
            
            // Approach 1: Show yearly value only in Total column, leave months empty
            months.forEach(month => {
              row[`${month} ${selectedYear}`] = "";
            });
            
            // Approach 2: Distribute yearly value equally across all months
            // const monthlyValue = yearlyValue / 12;
            // months.forEach(month => {
            //   row[`${month} ${selectedYear}`] = monthlyValue.toFixed(2);
            //   groupMonthTotals[month] += monthlyValue;
            // });
            
            // Approach 3: Show same yearly value in all months (not recommended)
            // months.forEach(month => {
            //   row[`${month} ${selectedYear}`] = yearlyValue.toFixed(2);
            //   groupMonthTotals[month] += yearlyValue;
            // });
            
            // Set unit from yearly data
            row["UOM"] = getUnitDisplay(field, yearlyData);
            
          } else {
            // Handle monthly/daily data (existing logic)
            months.forEach(month => {
              const monthIndex = months.indexOf(month) + 1; // 1-based month
              
              // Monthly records
              const monthlySum = approvedData
                .filter(item =>
                  String(item.fieldId) === String(field.fieldId) &&
                  item.frequencyType === "Monthly" &&
                  String(item.frequencyYear) === expectedYear &&
                  item.frequencyMonth?.toLowerCase() === month.toLowerCase()
                )
                .reduce((sum, item) => sum + (Number(item.prevValue) || 0), 0);
              
              // Daily records
              const dailySum = approvedData
                .filter(item => {
                  if (
                    String(item.fieldId) !== String(field.fieldId) ||
                    item.frequencyType !== "Daily" ||
                    !item.frequencyDate
                  ) return false;
                  
                  const date = new Date(item.frequencyDate);
                  return (
                    date.getFullYear() === Number(selectedYear) &&
                    date.getMonth() + 1 === monthIndex
                  );
                })
                .reduce((sum, item) => sum + (Number(item.prevValue) || 0), 0);
              
              const total = monthlySum + dailySum;
              row[`${month} ${selectedYear}`] = total > 0 ? Number(total).toFixed(2) : "";
              totalSum += total;
              groupMonthTotals[month] += total;
              
              // Set unit only once
              if (!row["UOM"]) {
                const match = approvedData.find(item => 
                  String(item.fieldId) === String(field.fieldId) && 
                  ((item.frequencyType === "Monthly" && 
                    String(item.frequencyYear) === expectedYear && 
                    item.frequencyMonth?.toLowerCase() === month.toLowerCase()) || 
                   (item.frequencyType === "Daily" && 
                    item.frequencyDate && 
                    new Date(item.frequencyDate).getFullYear() === Number(selectedYear) && 
                    new Date(item.frequencyDate).getMonth() + 1 === monthIndex))
                );
                if (match) {
                  row["UOM"] = getUnitDisplay(field, match);
                }
              }
            });
          }
          
          // Set total value
          row["Total"] = totalSum > 0 ? Number(totalSum).toFixed(2) : "";
          groupTotalSum += totalSum;
          
          // Add to group totals only if not yearly data (to avoid double counting)
          if (!hasYearlyData) {
            // Monthly totals already added in the loop above
          } else {
            // For yearly data using Approach 1, we don't add to monthly totals
            // The group total will include the yearly value
          }
          
          excelData.push(row);
        });
      }
      
      // Add summary row for group totals
      const groupSummaryRow = {
        "Sr. No.": "",
        "KPI Name": `${groupLabel} Total`,
        "UOM": "",
      };
      
      months.forEach(month => {
        groupSummaryRow[`${month} ${selectedYear}`] = groupMonthTotals[month] > 0 ? 
          Number(groupMonthTotals[month]).toFixed(2) : "";
      });
      groupSummaryRow["Total"] = groupTotalSum > 0 ? Number(groupTotalSum).toFixed(2) : "";
      excelData.push(groupSummaryRow);
    }
    
    if (excelData.length === 0) {
      showAlert("Nothing to export");
      return;
    }
    
    const unitName = getCompanyUnitName?.() ?? "Unknown Unit";
    const sheetData = [
      ["Client Name", "Harman Finochem Limited"],
      ["Location", unitName],
      [], // Empty row
    ];
    
    if (excelData.length > 0) {
      const headers = Object.keys(excelData.find(row => Object.keys(row).length > 0) || {});
      sheetData.push(headers);
      excelData.forEach(obj => {
        const row = headers.map(h => obj[h] ?? "");
        sheetData.push(row);
      });
    }
    
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Waste Monthly Summary");
    XLSX.writeFile(workbook, `Waste_KPI_Summary_${selectedYear}.xlsx`);
    showAlert("Excel downloaded successfully", true);
    
  } catch (err) {
    console.error("Download error", err);
    showAlert(err.message || "Failed to export");
  }
};



  const columns = React.useMemo(
    () => [
      {
        Header: "Sr. No.",
        Cell: ({ row: { _index } }) => _index + 1,
      },
      {
        Header: "Frequency Type",
        Cell: ({
          row: {
            _original: { frequencyType },
          },
        }) => frequencyType || "-",
        // original?.frequencyMonth
      },
      {
        Header: "Frequency Date",
        Cell: ({
          row: {
            _original: { frequencyDate },
          },
        }) => frequencyDate || "-",
      },
      {
        Header: "Frequency Month",
        Cell: ({
          row: {
            _original: { frequencyMonth },
          },
        }) => frequencyMonth || "-",
      },
      {
        Header: "Frequency Year",
        Cell: ({
          row: {
            _original: { frequencyYear },
          },
        }) => frequencyYear || "-",
      },
      {
        Header: "Updated By",
        width: 150,
        Cell: ({
          row: {
            _original: { updater, creater, updatedAt },
          },
        }) => {
          const updaterName = updater?.first_name
            ? `${updater.first_name} ${updater.last_name}`
            : creater?.first_name
            ? `${creater.first_name} ${creater.last_name}`
            : "-";
          const formattedDate = updatedAt
            ? new Date(updatedAt).toLocaleDateString("en-GB")
            : "";

          return (
            <div>
              <div>{updaterName}</div>
              {formattedDate && (
                <div style={{ fontSize: "0.8em", color: "gray" }}>
                  ({formattedDate})
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: "Status",
        Cell: ({
          row: {
            _original: { approvalStatus },
          },
        }) => (approvalStatus === "approved" ? "Approved" : "Pending" || "-"),
      },
      {
        Header: "Approved By",
        width: 150,
        Cell: ({
          row: {
            _original: { approver, approvedAt },
          },
        }) => {
          const approverName = approver?.first_name
            ? `${approver.first_name} ${approver.last_name}`
            : "-";
          const formattedDate = approvedAt
            ? new Date(approvedAt).toLocaleDateString("en-GB")
            : "";

          return (
            <div>
              <div>{approverName}</div>
              {formattedDate && (
                <div style={{ fontSize: "0.8em", color: "gray" }}>
                  ({formattedDate})
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: "View",
        Cell: ({
          row: {
            _original: { formId, approvalStatus },
          },
        }) => {
          return (
            <span
              onClick={() => {
                navigate(isLoggedIn ? "/company/data" : "/admin/data", {
                  state: { formId, page: "waste", store: "wasteStore" , approvalStatus : approvalStatus},
                });
              }}
              className="btn btn-primary btn-sm btn-action waves-effect waves-light"
            >
              View
            </span>
          );
        },
      },
      {
        Header: "Log",
        Cell: ({
          row: {
            _original: { formId },
          },
        }) => (
          <i
            type="button"
            onClick={() => handleModalLogShow(formId)}
            className="mdi mdi-dots-vertical"
          ></i>
        ),
      },
      // {
      //   Header: "Actions",
      //   width: 270,
      //   Cell: ({
      //     row: {
      //       _original: { formId, approvalStatus },
      //     },
      //   }) => (
      //     <div style={{ display: "flex", gap: "10px" }}>
      //       {approvalStatus === ApprovalEnums.Approved ? (
      //         <span>-</span>
      //       ) : (
      //         <>
      //           {user.role === USER_ROLE.Company || kpi.isApproved ? (
      //             <>
      //               <button
      //                 className="btn btn-success btn-sm"
      //                 onClick={() => handleModalOpen("approve", formId)}
      //               >
      //                 Approve
      //               </button>
      //               <button
      //                 className="btn btn-primary btn-sm btn-action waves-effect waves-light"
      //                 onClick={() =>
      //                   navigate("/company/approve/environment", {
      //                     state: {
      //                       formId,
      //                       groupConstant: "waste",
      //                       type: "waste",
      //                       kpiName,
      //                       year,
      //                     },
      //                   })
      //                 }
      //               >
      //                 Edit
      //               </button>
      //               <button
      //                 className="btn btn-danger btn-sm"
      //                 onClick={() => handleModalOpen("delete", formId)}
      //               >
      //                 Delete
      //               </button>
      //             </>
      //           ) : (
      //             <>
      //               {kpi && (
      //                 <>
      //                   {kpi.isEdited && (
      //                     <button
      //                       className="btn btn-primary btn-sm btn-action waves-effect waves-light"
      //                       onClick={() =>
      //                         navigate("/company/approve/environment", {
      //                           state: {
      //                             formId,
      //                             groupConstant: "waste",
      //                             type: "waste",
      //                             kpiName,
      //                             year,
      //                           },
      //                         })
      //                       }
      //                     >
      //                       Edit
      //                     </button>
      //                   )}
      //                 </>
      //               )}
      //             </>
      //           )}
      //         </>
      //       )}
      //     </div>
      //   ),
      // },
      {
        Header: "Actions",
        width: 270,
        Cell: ({
          row: {
            _original: { formId, approvalStatus },
          },
        }) => (
          <div style={{ display: "flex", gap: "10px" }}>
            {approvalStatus === ApprovalEnums.Approved ? (
              <>
                {(user.role === USER_ROLE.Company || user.department === "Admin") ? (
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleModalOpen("delete", formId)}
                  >
                    Delete
                  </button>
                ) : (
                  <span>-</span>
                )}
              </>
            ) : (
              <>
                {user.role === USER_ROLE.Company || user.department === "Admin" || kpi.isApproved ? (
                  <>
                    <button
                      className="btn btn-success btn-sm"
                      onClick={() => handleModalOpen("approve", formId)}
                    >
                      Approve
                    </button>
                    <button
                      className="btn btn-primary btn-sm btn-action waves-effect waves-light"
                      onClick={() =>
                        navigate("/company/approve/environment", {
                          state: {
                            formId,
                            groupConstant: "waste",
                            type: "waste",
                            kpiName,
                            year,
                          },
                        })
                      }
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleModalOpen("delete", formId)}
                    >
                      Delete
                    </button>
                  </>
                ) : (
                  <>
                    {kpi?.isEdited && (
                      <button
                        className="btn btn-primary btn-sm btn-action waves-effect waves-light"
                        onClick={() =>
                          navigate("/company/approve/environment", {
                            state: {
                              formId,
                              groupConstant: "waste",
                              type: "waste",
                              kpiName,
                              year,
                            },
                          })
                        }
                      >
                        Edit
                      </button>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        ),
      }
      
    ],
    [isLoggedIn, kpi, kpiName, navigate, user.role]
  );


  //  const getFinancialYearFilter = (year, companyUnit) => ({
  //     frequencyYear: [year, year + 1],
  //     frequencyMonth: ['4','5','6','7','8','9','10','11','12','1','2','3'],
  //     companyUnit
  //   });
    

  useEffect(() => {
    fetchUnits();
   // fetchForms({ type: "waste", page, pageSize: 10, filter: { year } });

  //  fetchForms({
  //   type: "waste",
  //   page,
  //   pageSize: 10,
  //   filter: getFinancialYearFilter(year,companyUnit),
  // });
  fetchForms({
    type: "waste",
    page,
    pageSize: 12,
    filter: { year, companyUnit },
  });

  }, [fetchForms, fetchUnits, page, year, companyUnit]);

  const handleView = (formId) => {
    navigate(isLoggedIn ? "/company/data" : "/admin/data", {
      state: { formId, page: "waste", store: "wasteStore" },
    });
  };

  const handleEdit = (formId) =>
    navigate("/company/approve/environment", {
      state: {
        formId,
        groupConstant: "waste",
        type: "waste",
        kpiName,
        year,
      },
    });


    const monthOrderMap = {
      April: 3, May: 4, June: 5, July: 6, August: 7, September: 8,
      October: 9, November: 10, December: 11, January: 0, February: 1, March: 2,
    };
    
        const sortedRecords = [...(forms?.records || [])].sort((a, b) => {
          const monthA = monthOrderMap[a.frequencyMonth] ?? 99;
          const monthB = monthOrderMap[b.frequencyMonth] ?? 99;
        
          const yearA = Number(a.frequencyYear);
          const yearB = Number(b.frequencyYear);
        
          // First sort by year (if needed), then month order
          if (yearA !== yearB) {
            return yearA - yearB;
          }
        
          return monthA - monthB;
        });
        

  return (
    <div className="water-list">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 font-size-18">Waste</h4>
              <div className="page-title-right">
                {isLoggedIn && (
                  <div
                    style={{
                      display: "flex",
                      marginLeft: "auto",
                      width: "fit-content",
                    }}
                  >
                    <div className="text-sm-end d-flex gap-1 flex-wrap">
                      <Performance label="Waste" />
                      <Financials
                        groups={["A", "D", "E"].map((group) => ({
                          group,
                          label: FINANCIALS_LABELS.waste[group],
                        }))}
                        key="waste-financials"
                        guidance={PERMISSBLE_LIMIT_GUIDANCE}
                        units={units?.filter((e) =>
                          ["Metric tonn"].includes(e.name)
                        )}
                      />
                      <Link to={`/${path}/waste/add-waste`}>
                        <button
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#newCustomerModal"
                          className="btn btn-secondary waves-effect waves-light addCustomers-modal"
                        >
                          <i className="mdi mdi-plus me-1"></i> Add waste
                        </button>
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* End Page Title */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
          }}
        >
          {/* {Object.entries(STATIC_GROUPS.waste).map(([group, title]) => {
            // If group is a subgroup (like B1, B2, C1, etc.), combine parent and subgroup label
            let displayTitle = title;
            if (
              group.length > 1 &&
              STATIC_GROUPS.waste[group[0]] &&
              STATIC_GROUPS.waste[group]
            ) {
              displayTitle = `${STATIC_GROUPS.waste[group[0]]} ${STATIC_GROUPS.waste[group]}`;
            }
            return (
              <div
                style={{
                  flex: "1 1 calc(50% - 20px)",
                  boxSizing: "border-box",
                }}
                key={group}
              >
                <DashboardHistogram
                  title={displayTitle}
                  group={group}
                  reportType="waste"
                />
              </div>
            );
          })} */}
          {Object.entries(STATIC_GROUPS.waste)
  .filter(([group, title]) => {
    // ✅ Filter out sub-groups to prevent separate charts
    if (group.startsWith('B') && group !== 'B') return false; // Remove B1, B2, B3
    if (group.startsWith('C') && group !== 'C') return false; // Remove C1, C2
    return true; // Keep B, C, A, D, E, F, G
  })
  .map(([group, title]) => {
    let displayTitle = title;
    if (
      group.length > 1 &&
      STATIC_GROUPS.waste[group[0]] &&
      STATIC_GROUPS.waste[group]
    ) {
      displayTitle = `${STATIC_GROUPS.waste[group[0]]} ${STATIC_GROUPS.waste[group]}`;
    }
    return (
      <div
        style={{
          flex: "1 1 calc(50% - 20px)",
          boxSizing: "border-box",
        }}
        key={group}
      >
        <DashboardHistogram
          title={displayTitle}
          group={group}        // ✅ Now only B, C, A, D, E, F, G
          reportType="waste"
        />
      </div>
    );
  })}
        </div>

        <div className="row mt-4">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                {/* <div className="row mb-2 align-items-center">
                  <div className="col-xl-3">
                    <label className="form-label">
                      Filter data on Annual basis
                    </label>
                    <select
                      className="form-select"
                      value={year || new Date().getFullYear()}
                      onChange={(event) => setYear(Number(event.target.value))}
                    >
                      {Array.from({ length: 5 })
                        .map((_, i) => new Date().getFullYear() - i)
                        .map((v) => (
                          <option key={v} value={v}>{`FY ${v}-${
                            v + 1
                          }`}</option>
                        ))}
                    </select>
                  </div>
                  <div className="col-xl-3 d-flex align-items-end">
    <button
      type="button"
      className="btn btn-success waves-effect waves-light"
      onClick={handleDownloadExcel}
    >
      <i className="mdi mdi-download me-1"></i> Download Excel
    </button>
  </div>
                </div> */}



<div className="container">
  {/* First Row: Dropdown */}
  <div className="row mb-4">
    <div className="col-12 col-md-6 col-xl-4">
      <label className="form-label fw-semibold mb-2">
        Filter data on Annual basis
      </label>
      <select
        className="form-select"
        value={year || new Date().getFullYear()}
        onChange={(event) => setYear(Number(event.target.value))}
      >
        {Array.from({ length: 5 })
          .map((_, i) => new Date().getFullYear() - i)
          .map((v) => (
            <option key={v} value={v}>{`CY ${v}`}</option>
          ))}
      </select>
    </div>
  </div>

  {/* Second Row: Button */}
  <div className="row mb-4">
    <div className="col-12 col-md-6 col-xl-4">
      <button
        type="button"
        className="btn btn-success"
        onClick={handleDownloadExcel}
      >
        <i className="mdi mdi-download me-1"></i> Download Excel
      </button>
    </div>
  </div>
</div>



                <div className="table  dashboard-table">
                  {/* <DynamicTable
                    pageSize={forms?.records?.length || 0}
                    columns={columns}
                    data={forms?.records || []}
                  /> */}

                   <DynamicTable
                    pageSize={sortedRecords.length}
                    columns={columns}
                    data={sortedRecords}
                  />
                </div>
                <MobileTable
                  handleEdit={handleEdit}
                  handleModalOpen={handleModalOpen}
                  handleView={handleView}
                />
                <PaginationControls
                  page={page}
                  setPage={setPage}
                  totalPages={forms?.totalPages}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Existing component code */}

      {/* Approval Confirmation Modal */}
      <Modal
        show={showModal}
        onHide={handleModalClose}
        size={modalType === "log" ? "xl" : ""}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "approve"
              ? "Approve Form"
              : modalType === "delete"
              ? "Delete Form"
              : "Log Details"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ overflow: "hidden" }}>
          {modalType === "approve" && (
            <p>Are you sure you want to approve this form?</p>
          )}
          {modalType === "delete" && (
            <p>
              Are you sure you want to delete this form? Once deleted, all data
              associated with this form will be permanently removed and cannot
              be recovered.
            </p>
          )}
          {modalType === "log" && (
            <div style={{ overflowX: "auto" }}>
              <table className="table table-responsive scroll">
                <thead>
                  <tr key={12} className="waterTabletr">
                    <th key={0}>Username</th>
                    <th key={1}>Date</th>
                    <th key={2}>Action</th>
                    <th key={3}>Ip</th>
                    <th key={4}>Request</th>
                  </tr>
                </thead>
                <LogTableBody logRaw={logRaw} formId={selectedFormId} />
              </table>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Cancel
          </Button>
          {modalType === "approve" && (
            <Button variant="primary" onClick={handleConfirmAction}>
              Approve
            </Button>
          )}
          {modalType === "delete" && (
            <Button variant="primary" onClick={handleConfirmAction}>
              Delete
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default observer(WasteDashboard);
